"use strict";

function goBack() {
  return {
    restrict: "EA",
    replace: true,
    template: "<div class=\"button__bar button__bar--back {{classes}}\"><button class=\"button button__back\" type=\"button\" ng-click=\"goBack()\"><i class=\"fa fa-chevron-left\"></i><span>{{'back' | translate}}</span></button></div>",
    link: function($scope, elem, attrs) {
      $scope.classes = "";
      if (angular.isDefined(attrs.goBack)) {
        $scope.classes = attrs.goBack; 
      }
      $scope.goBack = function() {
        window.history.back();
      };
    }
  };
}

angular.module("dokiv")
  .directive("goBack", goBack);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/goBack.js
// module id = 261
// module chunks = 0